import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function inscripcionComboReducer(state= initialState.inscripcionCombo, action){
	switch(action.type){
		case types.GET_INSCRIPCIONS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}